import * as React from "react";
import { Button } from "react-bootstrap";
import * as types from "../types";

interface Props {
  selectSeat: (id: number, seat: types.Seat) => void;
  unselectSeat: (id: number) => void;
  isSeatSelected: (id: number) => boolean;
  spectacleId: number;
  seats: types.Seat[];
  spectacle: types.Spectacle;
  areaPrices: any;
  vatPrices: any;
  cart: types.CartItem[];
}

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const TicketSelector: React.FC<Props> = ({
  seats,
  cart,
  selectSeat,
  unselectSeat,
}) => {
  const cartIds = cart.map(cart => cart.SeatId);

  const freeSeatsInit = seats.filter(seat => {
    return !seat.reserved || cartIds.includes(seat.SeatId);
  });

  const [freeSeats, setFreeSeats] = React.useState<types.Seat[]>(freeSeatsInit);

  React.useEffect(() => {
    const cartIds = cart.map(cart => cart.SeatId);

    setFreeSeats(
      seats.filter(seat => {
        return !seat.reserved && !cartIds.includes(seat.SeatId);
      }),
    );
  }, [cart]);

  const addTicket = () => {
    if (freeSeats.length > 0) {
      const seat = getRandomInt(0, freeSeats.length - 1);
      selectSeat(freeSeats[seat].SeatId, freeSeats[seat]);
    }
  };

  const removeTicket = () => {
    if (cart[0]) {
      unselectSeat(cart[0].SeatId);
    }
  };

  return (
    <div className="d-flex flex-column pt-5">
      <p>Spektakl posiada nienumerowaną widownie</p>

      <div>
        <Button className="m-1" onClick={addTicket}>
          Dodaj bilet
        </Button>

        <Button type="submit" className="m-1" onClick={removeTicket}>
          Usuń bilet
        </Button>
      </div>

      <div>
        <p>Wolne miejsca: {freeSeats.length}</p>
        <p>Zajęte miejsca: {seats.length - freeSeats.length}</p>
        <p>Wybrane miejsca: {cart.length}</p>
      </div>
    </div>
  );
};

export default TicketSelector;
